<template>
  <div id="filter-block" class=" products-filters-view brand-manitou">
    <div class="content">
      <a class="close-button" v-on:click="$root.$emit('close-sort-mobile');">
        <i class="fas fa-times"></i>
      </a>
      <h2><i class="fa fa-sort"></i> {{$t('sort')}}</h2>
      <div>
        <b-button
            rounded
            class="button is-small is-rounded is-uppercase switch-button"
            :class="{'switch-active': sortValue==='name/1'}"
            @click="sortValue='name/1'"

        >{{ $t('alpha_order') }} ({{$t('ascendant')}})</b-button>
        <b-button
            rounded
            class="button is-small is-rounded is-uppercase switch-button"
            :class="{'switch-active': sortValue==='name/0'}"
            @click="sortValue='name/0'"

        >{{ $t('alpha_order') }} ({{$t('descendant')}})</b-button>



        <template
            v-for="attribute in filtersList"
        >
          <b-button
              :key="attribute.attribute+'/1'"
              rounded
              class="button is-small is-rounded is-uppercase switch-button"
              :class="{'switch-active': sortValue===attribute.attribute+'/1'}"
              @click="sortValue=attribute.attribute+'/1'"

          >{{ attribute.title }} ({{$t('ascendant')}})</b-button>
          <b-button
              :key="attribute.attribute+'/0'"
              rounded
              class="button is-small is-rounded is-uppercase switch-button"
              :class="{'switch-active': sortValue===attribute.attribute+'/0'}"
              @click="sortValue=attribute.attribute+'/0'"

          >{{ attribute.title }} ({{$t('descendant')}})</b-button>
        </template>

        <b-button
            rounded
            class="button is-small is-rounded is-uppercase switch-button"
            :class="{'switch-active': sortValue==='isBestSeller/0'}"
            @click="sortValue='isBestSeller/0'"

        >Best seller</b-button>

        <b-button
            rounded
            class="button is-small is-rounded is-uppercase switch-button"
            :class="{'switch-active': sortValue==='isNew/0'}"
            @click="sortValue='isNew/0'"

        >{{$t('new')}}</b-button>
      </div>

      <div class="has-text-centered">
        <b-button rounded class="button is-primary is-large is-rounded is-uppercase is-background-color-red is-full" @click="search();$emit('close')">Valider <span class="fa fa-check"></span></b-button>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";

import formMixins from "@/common/mixins/form";
import filtersMixins from "@/common/mixins/filters";
import {mapState} from "vuex";

export default {
  name: "FiltersListMobile",
  components: {
    VueSlider
  },
  mixins: [
    formMixins,
    filtersMixins
  ],

  props : {
    filters: {
      type:Array,
      require:true,
      default : ()=>[]
    },
  },

  data() {
    return {
      sortValue:this.sort
    }
  },

  computed: {
    ...mapState({
      filtersList: state => state.searchMachines.filtersList,
      sort: state => state.searchMachines.sort
    }),
  },
  methods : {
    search() {
      this.$root.$emit('select_sort',this.sortValue)
      this.$root.$emit('close-sort-mobile')
    },

  }

}
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/config/_config.scss";

#filter-block{
  background: #ffffff;

  h2 {
    font-size:2rem;
    font-weight:bold;
    margin-bottom:35px;

    i {font-size:1.5rem}
  }

  .filter-title {
    font-size:1.2em;
    font-weight:900;
    margin-bottom:0px;
  }

  .slider-range {
    height:200px;
  }

  .close-button {
    position: absolute;
    right: 5px;
    top: 0px;
    font-size: 1.5rem;
    font-weight: lighter;
  }

  .content {
    padding: 2rem 0rem;
    position: relative;

  }

  .select-container {
    justify-content:center;
  }

  .button {
    margin:20px auto;
    span {margin-left:20px}
  }
}

.switch-button {
  background-color:$white;
  color:$blackish;
  display:block;
  border-color:$white;
  //white-space: break-spaces!important;
  height:auto;

  &:hover {
    border-color:$grey-light;
  }

  &.switch-active {
    color:$white;
    background-color:$blackish;
    border-color:$blackish;
  }
}

.modal-close {
  display: none
}
</style>